import axios, { AxiosError } from 'axios';
import { LATEST_VERSION, V1, VERSION_HEADER } from '~/constants/api';
import { readFromLocalStorage } from '~/utils/local-storage';

function setupBaseHeaders(envId: string) {
  const baseHeaders: Record<string, string> = {
    [VERSION_HEADER]: LATEST_VERSION,
  };

  if (envId === 'production') return baseHeaders;

  baseHeaders['X-HTTP-Request-Source'] = `React-${envId}`;
  const lang = readFromLocalStorage('i18nextLng');
  if (lang) {
    baseHeaders['Accept-Language'] = lang;
  }

  return baseHeaders;
}

export function setupAuthentication(jwt?: string) {
  const configureHeaders =
    (useShippoToken = false) =>
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (config: Record<string, any>) => {
      // use ShippoToken auth on specific services when appropriate -- e.g. for dev-qa microservices called from
      // local dev --but JWT otherwise
      const auth =
        useShippoToken && CONFIG.shippoToken ? `ShippoToken ${CONFIG.shippoToken}` : `JWT ${jwt}`;

      config.headers = {
        ...config.headers,
        Authorization: auth,
      };

      return config;
    };

  api.interceptors.request.use(configureHeaders());
  microServiceAPI.interceptors.request.use(configureHeaders(true));
  armorAPI.interceptors.request.use(configureHeaders());
  djangoApi.interceptors.request.use(configureHeaders());
  apiV1.interceptors.request.use(configureHeaders());
  storeConnectApi.interceptors.request.use(configureHeaders());
  analyticsApi.interceptors.request.use(configureHeaders());
}

export type ApiError = AxiosError;

export const sisenseAPI = axios.create({
  baseURL: CONFIG.sisenseUrl,
});

const api = axios.create({
  baseURL: CONFIG.apiBaseUrl,
  headers: setupBaseHeaders(ENV_ID),
});

export const microServiceAPI = axios.create({
  baseURL: CONFIG.microServiceBaseUrl,
  headers: {
    ...setupBaseHeaders(ENV_ID),
  },
});

export const armorAPI = axios.create({
  baseURL: CONFIG.armorUrl,
  headers: setupBaseHeaders(ENV_ID),
});

export const unauthApi = axios.create({
  baseURL: CONFIG.apiBaseUrl,
  headers: setupBaseHeaders(ENV_ID),
});

export const djangoApi = axios.create({
  baseURL: CONFIG.djangoBaseUrl,
  headers: setupBaseHeaders(ENV_ID),
});

export const storeConnectApi = axios.create({
  baseURL: CONFIG.storeConnectUrl,
  headers: setupBaseHeaders(ENV_ID),
});

export const analyticsApi = axios.create({
  baseURL: CONFIG.analyticsUrl,
  headers: setupBaseHeaders(ENV_ID),
});

export const apiV1 = axios.create({
  baseURL: CONFIG.apiBaseUrl,
  headers: {
    ...setupBaseHeaders(ENV_ID),
    [VERSION_HEADER]: V1,
  },
});

export default api;
